import { render, staticRenderFns } from "./CategoryFrm.vue?vue&type=template&id=0e026a0a&"
import script from "./CategoryFrm.vue?vue&type=script&lang=js&"
export * from "./CategoryFrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports